/* (ignored) */


//////////////////
// WEBPACK FOOTER
// canvas (ignored)
// module id = 38
// module chunks = 0